import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

// Define the types for the props
interface HeadingCardProps {
  titleone?: string;
  titletwo?: string;
  displayC?: string;
  onRightSectionClick?: () => void; // Make the function optional
}

const HeadingLeftRight: React.FC<HeadingCardProps> = ({
  titleone,
  titletwo,
  displayC,
  onRightSectionClick,
}) => {
  return (
    <Grid item xs={12} md={12} className="document-container">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {/* Left Section: Overview */}
        <Typography className="loan-account-sub-headings">
          {titleone}
        </Typography>

        {/* Right Section: View all loans */}
        {titletwo && (
          <Box
            display="flex"
            alignItems="center"
            sx={{ cursor: "pointer" }}
            onClick={onRightSectionClick}
          >
            <Typography className="loan-account-sub-headings">
              {titletwo}
            </Typography>
            {displayC !== "true" && (
              <KeyboardArrowRightIcon
                sx={{ color: "#168794", fontSize: "18px" }}
              />
            )}
          </Box>
        )}
      </Box>
    </Grid>
  );
};

export default HeadingLeftRight;
